import { render, staticRenderFns } from "./AddOrganisation.vue?vue&type=template&id=cabbe5a8&scoped=true"
import script from "./AddOrganisation.vue?vue&type=script&lang=js"
export * from "./AddOrganisation.vue?vue&type=script&lang=js"
import style0 from "./AddOrganisation.vue?vue&type=style&index=0&id=cabbe5a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbe5a8",
  null
  
)

export default component.exports